<template>
  <div class="card card-body p-0 mb-3 border border-dark py-1">
    <div class="table-responsive">
      <table class="table table-striped m-0 text-start" aria-label="Admin">
        <thead>
          <tr>
            <th scope="col">
              <button
                class="btn btn-link text-decoration-none p-0"
                @click="setSortKey('fullname')"
              >
                <span class="pe-1 fw-bold">Name</span>
                <span v-show="sortKey == 'fullname'">
                  <i
                    v-show="sortDirection === 'asc'"
                    class="bi bi-sort-alpha-down"
                  ></i>
                  <i
                    v-show="sortDirection === 'desc'"
                    class="bi bi-sort-alpha-up"
                  ></i>
                </span>
              </button>
            </th>
            <th scope="col">
              <button
                class="btn btn-link text-decoration-none p-0"
                @click="setSortKey('onid')"
              >
                <span class="pe-1 fw-bold">ONID</span>
                <span v-show="sortKey == 'onid'">
                  <i
                    v-show="sortDirection === 'asc'"
                    class="bi bi-sort-alpha-down"
                  ></i>
                  <i
                    v-show="sortDirection === 'desc'"
                    class="bi bi-sort-alpha-up"
                  ></i>
                </span>
              </button>
            </th>
            <th scope="col">Percent</th>
            <th scope="col">Link</th>
            <th scope="col" class="text-end">
              <button
                class="btn btn-link text-decoration-none p-0"
                @click="setSortKey('tsUpdatedLabel')"
              >
                <span class="pe-1 fw-bold">Last Updated</span>
                <span v-show="sortKey == 'tsUpdatedLabel'">
                  <i
                    v-show="sortDirection === 'asc'"
                    class="bi bi-sort-numeric-down"
                  ></i>
                  <i
                    v-show="sortDirection === 'desc'"
                    class="bi bi-sort-numeric-up"
                  ></i>
                </span>
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="entry in sortedEntries" :key="entry.id">
            <td>{{ entry.fullname }}</td>
            <td>{{ entry.onid }}</td>
            <td><ProgressBar :formData="entry?.value?.formData" /></td>
            <td>
              <RouterLink
                :to="{ name: 'ExportView', params: { onid: entry.onid } }"
                >Link</RouterLink
              >
            </td>
            <td class="text-end">{{ entry.tsUpdatedLabel }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
/*
 * If you need to display specific data properties,
 * you can add in new <td> with `entry.value`, for example.
 */

import ProgressBar from "@/components/sidebar/ProgressBar.vue";
export default {
  name: "AdminTable",
  components: {
    ProgressBar
  },
  data() {
    return {
      sortKey: "name",
      sortDirection: "asc"
    };
  },
  props: {
    entries: Array
  },
  computed: {
    // Copilot
    sortedEntries() {
      let _arr = [...this.entries];

      _arr.sort((a, b) => {
        if (this.sortDirection === "asc") {
          return a[this.sortKey] > b[this.sortKey] ? 1 : -1;
        } else {
          return a[this.sortKey] < b[this.sortKey] ? 1 : -1;
        }
      });

      return _arr;
    }
  },
  methods: {
    // Copilot
    setSortKey(key) {
      if (this.sortKey === key) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortDirection = "asc";
      }
      this.sortKey = key;
    }
  }
};
</script>
